import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from "axios";
import i18n from "./i18n"
// import DisableAutocomplete from 'vue-disable-autocomplete';
// Vue.use(DisableAutocomplete);

Vue.config.productionTip = false

new Vue({
  iconfont: 'mdi',
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

axios.defaults.headers.common['Language'] = navigator.language;
// const token = localStorage.getItem('token')
// if (token) {
//   axios.defaults.headers.common['Authorization'] = token;
//   //axios.defaults.headers.common['Authorization'] = token;
  
//   //axios.defaults.headers.common['Language'] = "fr-FR";
// }


